
  <dx-popup class="popup"
            [showTitle]="true"
            [title]="'Mappe-Bezeichnung ändern'"
            [dragEnabled]="false"
            [height]="'auto'"
            [width]="'50%'"
            [hideOnOutsideClick]="false"
            (onShowing)="onShowingPopup($event)"
            (onHidden)="onHiddenPopup($event)"
            [(visible)]="popupVisible">
    <div *dxTemplate="let data of 'content'">

      <dx-form #form [(formData)]="context">
        <dxi-item dataField="bezeichnung" [label]="{text: 'Bezeichnung'}">
          <dxi-validation-rule type="required" message="'Bezeichnung' wird benötigt!"></dxi-validation-rule>
        </dxi-item>
      </dx-form>
    </div>

    <dxi-popup-toolbar-item widget="dxButton"
                      location="after"
                      toolbar="bottom"
                      [options]="{
            text: 'Übernehmen',
            onClick: onClickUebernehmen
        }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton"
                      location="after"
                      toolbar="bottom"
                      [options]="{
            text: 'Abbrechen',
            onClick: onClickClose
        }">
    </dxi-popup-toolbar-item>
  </dx-popup>
